import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function CardSkeleton() {
  return (
    <Card className="overflow-hidden py-3">
      <div className="flex items-stretch gap-3 px-3 py-0 md:px-4">
        <div className="flex-1 min-w-0 space-y-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-48" />
        </div>

        <div className="w-px bg-gray-200 self-stretch" />

        <div className="flex flex-col gap-2 flex-shrink-0 w-24">
          <Skeleton className="h-7 w-24 rounded-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    </Card>
  );
}
